import React, { memo, useMemo } from 'react'
import { Modal, Typography } from '@mui/material'
import tw from 'twin.macro'
import {
  ChatMajor,
  ChevronRightMinor,
  CircleRightMajor,
  MobileCancelMajor,
} from '@shopify/polaris-icons'
import Logo from 'src/assets/images/gigsafe-logo-black.svg'
import { Button } from '../shared/Button'
import RecollectIcon from 'src/assets/icons/recollect.svg'
import { GigSafeMemberBenefitPortal } from '../shared/GigSafeMemberBenefitPortal'

interface Props {
  isOpen: boolean
  onClose: () => void
  onLogout?: () => void
  onGetHelp: () => void
  onSwitchPartner?: () => void
  menuTestIdPrefix: string
  showBenefitPortal?: boolean
}

const MobileMenuComponent = ({
  isOpen,
  onClose,
  onLogout,
  onSwitchPartner,
  onGetHelp,
  menuTestIdPrefix,
  showBenefitPortal = true,
}: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`w-full h-full`}
    >
      <div css={tw`w-full h-full flex flex-col`}>
        <div css={tw`flex px-4 py-3 justify-between items-center bg-shades-0`}>
          <img src={Logo} />
          <Button
            leftIcon={<MobileCancelMajor css={tw`mx-1`} width={20} height={20} />}
            onClick={onClose}
            color="grey"
            size="medium"
            data-testid={`${menuTestIdPrefix}-menu-close-btn`}
          />
        </div>
        <div css={tw`bg-shades-50 p-4 h-fit flex-1 flex flex-col`}>
          <div css={tw`bg-shades-0 rounded-2xl overflow-hidden`}>
            {onSwitchPartner ? (
              <div
                css={tw`p-4 flex items-center justify-between hover:bg-shades-100 active:bg-shades-200`}
                onClick={onSwitchPartner}
                data-testid={`${menuTestIdPrefix}-switch-partner`}
              >
                <div css={tw`flex items-center`}>
                  <div
                    css={tw`h-11 w-11 rounded-[22px] items-center justify-center flex bg-shades-50`}
                  >
                    <img src={RecollectIcon} />
                  </div>
                  <Typography fontWeight={600} css={tw`ml-4`}>
                    Switch partner
                  </Typography>
                </div>
                <ChevronRightMinor css={tw`fill-shades-300`} width={20} height={20} />
              </div>
            ) : null}
            <div
              css={tw`p-4 flex items-center justify-between hover:bg-shades-100 active:bg-shades-200`}
              onClick={onGetHelp}
              data-testid={`${menuTestIdPrefix}-get-help`}
            >
              <div css={tw`flex items-center`}>
                <div
                  css={tw`h-11 w-11 rounded-[22px] items-center justify-center flex bg-shades-50`}
                >
                  <ChatMajor width={20} height={20} />
                </div>
                <Typography fontWeight={600} css={tw`ml-4`}>
                  Get Help
                </Typography>
              </div>
              <ChevronRightMinor css={tw`fill-shades-300`} width={20} height={20} />
            </div>
            {onLogout ? (
              <div
                css={tw`p-4 flex items-center justify-between hover:bg-shades-100 active:bg-shades-200`}
                onClick={onLogout}
                data-testid={`${menuTestIdPrefix}-log-out`}
              >
                <div css={tw`flex items-center`}>
                  <div
                    css={tw`h-11 w-11 rounded-[22px] items-center justify-center flex bg-shades-50`}
                  >
                    <CircleRightMajor width={20} height={20} />
                  </div>
                  <Typography fontWeight={600} css={tw`ml-4`}>
                    Log out
                  </Typography>
                </div>
                <ChevronRightMinor css={tw`fill-shades-300`} width={20} height={20} />
              </div>
            ) : null}
          </div>
          {showBenefitPortal ? (
            <div css={tw`my-4`}>
              <GigSafeMemberBenefitPortal />
            </div>
          ) : null}
        </div>
      </div>
    </Modal>
  )
}

export const MobileMenu = memo(MobileMenuComponent)
